import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import QueryString from 'qs';
import { useEffect, useState } from 'react';

const useOpenIterationSummary = () => {
  const { iteration_summary: isIterationSummaryInQs } = QueryString.parse(
    window.location.search,
    {
      ignoreQueryPrefix: true
    }
  );

  const { getSettingOrDefinitionValue } = useSettingsService();

  const isVisionInsightsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isVisionInsightsEnabled
  });

  const [shouldShowIterationSummary, setShouldShowIterationSummary] =
    useState(false);

  useEffect(() => {
    if (isIterationSummaryInQs && isVisionInsightsEnabled) {
      const timer = setTimeout(() => {
        setShouldShowIterationSummary(true);
      }, 250);

      return () => clearTimeout(timer);
    }
  }, [isIterationSummaryInQs, isVisionInsightsEnabled]);

  return { shouldShowIterationSummary, isIterationSummaryInQs };
};

export default useOpenIterationSummary;
